import { Component, inject, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/alert-notify/alert-notify.service';
import { AuthService } from 'src/services/auth.service';
import { VendorService } from 'src/services/vendor.service';

@Component({
    selector: 'app-ecitation-court',
    templateUrl: './ecitation-court.component.html',
    styleUrls: ['./ecitation-court.component.css'],
    standalone: false
})
export class EcitationCourtComponent {
	private modalService = inject(NgbModal);

	closeResult = '';
	listAllCourtDetails: any = [];
	masterList: any = [];
	listAllVendors: any = [];
	listStatusCodes: any = [];
	loggedInUserName = '';
	mode = '';
	alert: any;
	cIteam: any;
	userType: any;

	courtForm!: FormGroup;

	pageSize: number = 25;
	currentPage: number = 1;

	constructor(
		private _formBuilder: FormBuilder,
		private vendorService: VendorService,
		public alertService: AlertService,
		public authService: AuthService
	) { }

	ngOnInit() {
		const loginData = sessionStorage.getItem('loggedInUser');
		this.userType = this.authService.getUserType();
		const item = loginData && JSON.parse(loginData || '{}');
		this.loggedInUserName = item?.username ?? '';

		this.courtForm = this._formBuilder.group({
			courtName: ['', [Validators.required]],
			courtNumber: ['', [Validators.required, Validators.maxLength(8), Validators.minLength(8)]],
			apiPassword: ['', [Validators.required]],
			courtStatusDesc: ['', [Validators.required]],
			vendorName: ['', [Validators.required]]
		});

		this.getAllVendors();
		this.getAllStatusCodes();
		this.getAllCourt();
	}

	/** Helper to get a typed FormControl for template bindings */
	getFormControl(name: string): FormControl {
		return this.courtForm.get(name) as FormControl;
	}

	getAllCourt() {
		this.vendorService.getAllCourt().subscribe((res) => {
			this.listAllCourtDetails = res;
			this.masterList = res;
		});
	}

	getAllVendors() {
		this.vendorService.getAllVendor().subscribe((res) => {
			this.listAllVendors = res;
		});
	}

	getAllStatusCodes() {
		this.vendorService.getAllStatusCodes().subscribe((res) => {
			this.listStatusCodes = res;
		});
	}

	getItems() {
		const satrtIndex = (this.currentPage - 1) * this.pageSize;
		return this.listAllCourtDetails.slice(satrtIndex, satrtIndex + this.pageSize);
	}

	onPageChange(pageNumber: number) {
		this.currentPage = pageNumber;
	}

	getTotalPages(): number {
		return Math.ceil(this.listAllCourtDetails.length / this.pageSize);
	}

	getVisiblePages(): number[] {
		const totalVisiblePages = 10;
		const visiblePages: number[] = [];
		const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
		const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
		for (let i = startPage; i <= endPage; i++) visiblePages.push(i);
		return visiblePages;
	}

	generatePass() {
		const password = this.generateRandomPassword(16);
		const ctrl = this.courtForm.get('apiPassword');
		if (ctrl) {
			ctrl.setValidators([Validators.required]);
			ctrl.setValue(password);
			this.courtForm.markAsDirty();
			ctrl.updateValueAndValidity();
		}
	}

	generateRandomPassword(length: number) {
		const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const randomValue = new Uint32Array(Math.ceil(length / 2));
		window.crypto.getRandomValues(randomValue);
		let randomString = '';
		for (let i = 0; i < length; i++) {
			const randomIndex = randomValue[i % randomValue.length] % charset.length;
			randomString += charset[randomIndex];
		}
		return randomString;
	}

	open(content: TemplateRef<any>) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => (this.closeResult = `Closed with: ${result}`),
			(reason) => (this.closeResult = `Dismissed ${this.getDismissReason(reason)}`)
		);
	}

	addEdit(content: TemplateRef<any>, mode: any, item: any) {
		this.alert = null;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => (this.closeResult = `Closed with: ${result}`),
			(reason) => (this.closeResult = `Dismissed ${this.getDismissReason(reason)}`)
		);

		this.courtForm.reset();
		this.mode = mode;

		if (mode === 'edit') {
			this.cIteam = item;
			const passCtrl = this.courtForm.get('apiPassword');
			if (passCtrl) {
				passCtrl.clearValidators();
				passCtrl.updateValueAndValidity();
			}
			this.courtForm.patchValue(item);
		}

		document.getElementById('courtName')?.focus();
	}

	addCourt() {
		if (this.courtForm.valid) {
			const formData = this.courtForm.value;
			let data: any;

			if (this.mode === 'add') {
				data = {
					courtNumber: formData.courtNumber,
					courtStatusDesc: formData.courtStatusDesc,
					courtName: formData.courtName,
					apiUserName: String(formData.courtNumber),
					apiPassword: formData.apiPassword,
					loggedInUserName: this.loggedInUserName,
					vendorName: formData.vendorName
				};
			} else {
				data = {
					courtId: this.cIteam.courtId,
					courtNumber: formData.courtNumber,
					courtStatusDesc: formData.courtStatusDesc,
					courtName: formData.courtName,
					apiUserName: String(formData.courtNumber),
					apiPassword: formData.apiPassword,
					loggedInUserName: this.loggedInUserName,
					previousVendorName: this.cIteam.vendorName,
					vendorName: formData.vendorName
				};
			}

			this.vendorService.addNewCourt(data).subscribe((res: any) => {
				if (res.errorMessage && res.errorMessage !== '') {
					this.alert = { message: res.errorMessage };
				} else {
					this.alert = null;
					this.cIteam = null;
					this.getAllCourt();
					this.courtForm.reset();
					this.modalService.dismissAll();

					const filterInp = document.getElementById('court-filter') as HTMLInputElement | null;
					if (filterInp) filterInp.value = '';

					this.alertService.success(
						this.mode === 'add'
							? `New court - ${formData.courtNumber} added sucessfully`
							: ` ${formData.courtNumber} updated sucessfully `
					);
				}
			});
		} else {
			for (const key in this.courtForm.controls) {
				this.courtForm.get(key)?.markAsTouched();
			}
		}
	}

	private getDismissReason(reason: any): string {
		switch (reason) {
			case ModalDismissReasons.ESC:
				return 'by pressing ESC';
			case ModalDismissReasons.BACKDROP_CLICK:
				return 'by clicking on a backdrop';
			default:
				return `with: ${reason}`;
		}
	}

	public filterList(event: any) {
		this.currentPage = 1;
		const q = (event?.target?.value ?? '').toLowerCase();
		this.listAllCourtDetails = this.masterList.filter((c: any) => {
			return c.courtName?.toLowerCase().includes(q) || String(c.courtNumber).toLowerCase().includes(q);
		});
	}

	onSort(event: any, name: any, isSortable: boolean) {
		if (isSortable) {
			const spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target;
			const classList = spanEle.classList;
			let sortDir = 1;
			if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
				classList.remove('fa-sort');
				classList.remove('fa-sort-up');
				classList.add('fa-sort-down');
				sortDir = -1;
			} else {
				classList.add('fa-sort-up');
				classList.remove('fa-sort-down');
			}
			this.sortBy(name, sortDir);
		}
	}

	sortBy(name: string, order: number) {
		this.listAllCourtDetails.sort((a: any, b: any) => {
			const av = isNaN(a[name]) ? String(a[name]).toLowerCase() : Number(a[name]);
			const bv = isNaN(b[name]) ? String(b[name]).toLowerCase() : Number(b[name]);
			return order === 1 ? (av < bv ? -1 : av > bv ? 1 : 0) : (bv < av ? -1 : bv > av ? 1 : 0);
		});
	}

	onlyNumber(event: KeyboardEvent) {
		if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].includes(event.key)) return;
		if (isNaN(parseInt(event.key)) || event.key === ' ' || event.key === '.') event.preventDefault();
	}

	getCurrentPageTotal() {
		return this.currentPage * 10 > this.listAllCourtDetails.length ? this.listAllCourtDetails.length : this.currentPage * 10;
	}
}
